import PropTypes from 'prop-types';
import React from 'react';
import RouterLink from 'components/RouterLink';
import { ResourceCardElement } from 'components/ResourceCardElements';
import styles from 'styles/resourceCard';
import cx from 'classnames';
import { fullAddress, deriveStatusName } from '../../../../../../../../utils';
import { urls } from 'helpers/url';
import DueDate from 'components/DueDate';
import PhaseTypeSpan from 'styledComponents';
import { PhaseIndexType } from 'types/phase';
import phaseCardStyles from '../phaseCard.scss';
import S from 'mobilePhaseCard.scss';

const MobilePhaseCard = ((props) => {
  const { surfaceName, cardColorCode, motColorCode, motTitle, mot, storeInfo, phase = {},
          phase: { customer_name, product_type, effective_due_at,
                   due_at, type, project_number } = {} } = props;

  const statusName = () => {
    const { status_name = '', workroom: { name: workroom = '' } = {}, source = '' } = phase || {};
    return deriveStatusName(status_name, { source, workroom });
  };

  return (<RouterLink
    to={urls.phase(phase)} className={phaseCardStyles.phaseLink}
  >
    <div
      className={cx(styles.aside, phaseCardStyles['aside-ss'], phaseCardStyles[cardColorCode])}
    >
      <ResourceCardElement
        wrap
        halfMobile
        title="Customer"
        size="full"
        theme={phaseCardStyles}
      >
        <h5 className={phaseCardStyles.title}>{customer_name}</h5>
        <p className={phaseCardStyles.productType}>{product_type}</p>
      </ResourceCardElement>
      <div className={phaseCardStyles.dueDate}>
        <DueDate
          date={effective_due_at}
          showText={false}
          isPhaseDetails={false}
        />
        {due_at !== effective_due_at && <span>
          <strong> - Flag Due</strong>
        </span>}
      </div>
    </div>
    <div className={phaseCardStyles.phaseColumnFlex}>
      <div className={styles.column}>
        <div className={styles.mobileColumn}>
          <PhaseTypeSpan>
            <ResourceCardElement
              halfMobile
              title="Phase Type"
              size="large"
              value={type}
              theme={S}
              phaseType={type}
            />
          </PhaseTypeSpan>
        </div>
        <div className={styles.mobileColumn}>
          <ResourceCardElement
            halfMobile
            title="Status"
            size="large"
            value={statusName()}
            theme={S}
          />
        </div>
        <div className={styles.mobileColumn}>
          <ResourceCardElement
            halfMobile
            title="Project #"
            size="small"
            value={project_number}
            theme={S}
          />
          <ResourceCardElement
            halfMobile
            title="Store #"
            size="small"
            theme={S}
            value={storeInfo.number}
          />
          <ResourceCardElement
            halfMobile
            title="Surface Type"
            size="small"
            value={surfaceName}
            theme={S}
          />
          <ResourceCardElement
            halfMobile
            title={motTitle}
            size="small"
            value={mot}
            className={phaseCardStyles[motColorCode]}
            theme={S}
          />
        </div>
      </div>
      <div className={styles.column}>
        <ResourceCardElement
          wrap
          noFlexMobile
          title="address"
          size="large"
          value={fullAddress(phase)}
          theme={S}
        />
      </div>
    </div>
  </RouterLink>);
});

MobilePhaseCard.propTypes = {
  role: PropTypes.string,
  phase: PhaseIndexType.isRequired,
  surfaceName: PropTypes.string,
  storeInfo: PropTypes.shape({
    number: PropTypes.string,
  }),
  cardColorCode: PropTypes.string.isRequired,
  motColorCode: PropTypes.string.isRequired,
  motTitle: PropTypes.string.isRequired,
  mot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default MobilePhaseCard;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/mobilePhaseCard.jsx